export const FETCH_SECTION_LIST = "FETCH_SECTION_LIST";
export const SET_ARTICLE_LIST = "SET_ARTICLE_LIST";
export const SET_SECTION_DETAILS = "SET_SECTION_DETAILS";
export const SEARCH_ARTICLE = "SEARCH_ARTICLE";
export const FETCH_TICKET_LIST = "FETCH_TICKET_LIST";
export const SET_AUTHOR_ID = "SET_AUTHOR_ID";
export const SET_TICKET_DETAILS = "SET_TICKET_DETAILS";
export const SET_TICKET_LIST_RELOAD = "SET_TICKET_LIST_RELOAD";
export const SET_DEVICETYPE = "SET_DEVICETYPE";
export const SET_USERID = "SET_USERID";
export const SET_NAME = "SET_NAME";
export const SET_EMAIL = "SET_EMAIL";
export const SET_CITY = "SET_CITY";
export const SET_CATEGORYID = "SET_CATEGORYID";
export const SET_USERIDv2 = "SET_USERIDv2";
export const SET_GUESTID = "SET_GUESTID";



// WEBPACK FOOTER //
// ./src/actions/types.js